import React, {useEffect, useState} from 'react';
import { GET_CATEGORIES_NAME } from '../../../services/graphql-query';
import { useQuery } from "@apollo/react-hooks";
import './footer.css'
import ListItem from '../layout/ListItem'
import Certificate from '../layout/Certification';
import { Container } from 'react-bootstrap';

import DLC from '../../assets/images/dssl-logos/DLC.png';
import ETL from '../../assets/images/dssl-logos/ETL.jpg';
import GSA from '../../assets/images/dssl-logos/GSA.jpg';
import MBE from '../../assets/images/dssl-logos/MBE.png';
import SAM from '../../assets/images/dssl-logos/SAM.jpg';

const logo_file = [DLC, ETL, GSA, MBE]

const Footer = () => {

    const [isCategory, setCategory] = useState([]);
    useEffect(() => {
    fetch(`/api/graphql/get-categories-name`,{
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
    })
        .then((response) => {
            return response.json();
        })
        .then((res) => {
            let category_uniques = [];
            let categories_data = res.data.categories.data.filter((element) => {
                const isDuplicate = category_uniques.includes(element.attributes.name);
                if (!isDuplicate) {
                    category_uniques.push(element.attributes.name);
                    return true;
                }
                return false;
            });

            setCategory(categories_data);
        });
    }, []);

    const navItems = [
        {
            title: 'PRODUCTS',
            children: isCategory
        },
        {
            title: 'RESOURCES',
            children: [
                'All Downloads', 'Case Studies', 'Warranties / Terms & Conditions'
            ]
        },
        {
            title: 'ABOUT DSSL',
            children: [
                'Our Store', 'Our Reps', 'Contact Us'
            ]
        },
        {
            title: 'GET IN TOUCH',
            children: [
                { icon: "phone", content: "1 888 886-DSSL (3775)" },
                { icon: "email", content: "sales@dssllighting.com" },
                { icon: "instagram", content: "Instagram" },
                { icon: "facebook", content: "Facebook" },
                { icon: "linkedin", content: "Linkedin" },
            ]
        }
    ]

    return (
        <React.Fragment>
            <div className='footer'>
                <Container className='footer-content row'>
                    <div className='col-md-3 d-flex align-items-center special-nav'>
                        <div className='element-group'>
                            <div className='footer-img' />
                            <div className='item-children'>1000 N Green Valley Pkwy, Suite 440 Henderson, NV 89074</div>
                            <div>
                                <div className='element-title'>CERTIFICATIONS</div>
                                <div className='element-content d-flex justify-content-between'>
                                    {
                                        logo_file.map((item, index) => <Certificate key={index} data={item} />)
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='col-md-1'></div>
                    {
                        navItems.map((item, index) => (
                            <div className='col-md-2' key={index}><ListItem data={item} /></div>
                        ))
                    }
                </Container>
                <span onClick={() => window.open('https://scalecampaign.com', "_blank")}>Powered by Scale Campaign</span>
            </div>
        </React.Fragment>
    )
}

export default Footer;
